import axios from 'axios';
import { getProject } from './gcloud/getProject';

export default async function getUsersService(projectUrl = getProject(), httpRequest = axios) {
  const config = {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${Date.now()}`
  };

  return await httpRequest({
    url: `${projectUrl}/getUsersV2`,
    method: 'GET',
    headers: config,
  })    
}